export enum MainMarketsTypes {
    ML = 1,
    HC = 2,
    OU = 3
}